"use client"

import React from "react"
import { Slide } from "react-awesome-reveal"
// import * as motion from "motion/react-client"
const SlideWrapper = ({ children, direction, ...restProps }) => {
  return (
    <Slide triggerOnce direction={direction} {...restProps}>
      {children}
    </Slide>
  )
}

export default SlideWrapper
